export default __webpack_public_path__ + "static/media/node.5a3dbbeb.svg";